module.exports = __webpack_public_path__ + "static/img/certificateCY.1e7b049d.jpg";